import { createSlice, createEntityAdapter } from '@reduxjs/toolkit'
import { RequestErrorResponse } from '../../services/lib/types'
import { PostEntity } from '../../services/endpoints/testCrud'

//todo be global
type InitialStateArgument = {
  loading: boolean
  error: null | RequestErrorResponse
}

const sliceName = 'posts'

const postsAdapter = createEntityAdapter<PostEntity>({
  selectId: i => i.id, //only needed if not id
  sortComparer: (a, b) => b.id.localeCompare(a.id),
})

const initialState = postsAdapter.getInitialState(<InitialStateArgument>{
  loading: false,
  error: null,
})

// export const getAllPosts = createAsyncThunk(
//   `${sliceName}/getAllPosts`,
//   async () => await postService.getAllPosts()
// )

// export const createPost = createAsyncThunk(
//   `${sliceName}/createPost`,
//   async (postData: CreateType) => await postService.createPost(postData)
// )

// export const updatePost = createAsyncThunk(
//   `${sliceName}/updatePost`,
//   async ({ id, title, content }: PostEntity) =>
//     await postService.updatePost(id, { title, content })
// )

// export const removePost = createAsyncThunk(
//   `${sliceName}/removePost`,
//   async (postId: string) => await postService.removePost(postId)
// )

const postsSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    // postsRetrieved: postsAdapter.setAll,
    // postAdded: postsAdapter.addOne,
    // postUpdated: postsAdapter.updateOne,
    // postRemoved: postsAdapter.removeOne,
  },
  extraReducers: () =>
    // builder: ActionReducerMapBuilder<
    //   EntityState<postService.PostEntity> & InitialStateArgument
    // >
    {
      // builder.addCase(getAllPosts.fulfilled, (state, action) => {
      //   state.loading = false
      //   state.error = null
      // })
      // builder.addCase(getAllPosts.pending, state => {
      //   state.loading = false
      //   state.error = null
      // })
      // builder.addCase(getAllPosts.rejected, (state, action) => {
      //   state.loading = false
      //   state.error = null
      // })
      // builder.addCase(createPost.fulfilled, (state, action) => {
      //   state.loading = false
      //   state.error = null
      // })
      // builder.addCase(createPost.pending, state => {
      //   state.loading = false
      //   state.error = null
      // })
      // builder.addCase(createPost.rejected, (state, action) => {
      //   state.loading = false
      //   state.error = null
      // })
      // builder.addCase(updatePost.fulfilled, (state, action) => {
      //   state.loading = false
      //   state.error = null
      // })
      // builder.addCase(updatePost.pending, state => {
      //   state.loading = false
      //   state.error = null
      // })
      // builder.addCase(updatePost.rejected, (state, action) => {
      //   state.loading = false
      //   state.error = null
      // })
      // builder.addCase(removePost.fulfilled, (state, action) => {
      //   state.loading = false
      //   state.error = null
      // })
      // builder.addCase(removePost.pending, state => {
      //   state.loading = false
      //   state.error = null
      // })
      // builder.addCase(removePost.rejected, (state, action) => {
      //   state.loading = false
      //   state.error = null
      // })
    },
})

// export const {
//   // postsRetrieved,
//   // postAdded,
//   // postUpdated,
//   // postRemoved,
// } = postsSlice.actions

export default postsSlice.reducer

export const {
  selectAll: selectAllPosts,
  selectById: selectPostById,
  selectIds: selectPostIds,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} = postsAdapter.getSelectors((state: any) => state.posts)

// export const selectPostsByUser = createSelector(
//   [selectAllPosts, (state, userId) => userId],
//   (posts, userId) => posts.filter(post => post.user === userId)
// )
